import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = { class: "app-btn__loader" }
const _hoisted_3 = {
  key: 0,
  class: "app-btn__icon"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 2,
  class: "app-btn__icon"
}

import { PropType } from 'vue';
import AppLoader from '@/components/AppLoader.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AppBtn',
  props: {
  circular: {
    type: Boolean,
    default: false,
  },
  size: {
    type: String as PropType<'sm' | 'lg'>,
    default: 'lg',
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass([
      'app-btn',
      `app-btn--${__props.size}`,
      __props.isLoading ? 'app-btn--loading' : '',
    ]),
    disabled: __props.disabled
  }, [
    _createElementVNode("span", _hoisted_2, [
      _createVNode(AppLoader)
    ]),
    (_ctx.$slots['icon-left'])
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
          _renderSlot(_ctx.$slots, "icon-left")
        ]))
      : _createCommentVNode("", true),
    (_ctx.$slots['default'])
      ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
          _renderSlot(_ctx.$slots, "default")
        ]))
      : _createCommentVNode("", true),
    (_ctx.$slots['icon-right'])
      ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
          _renderSlot(_ctx.$slots, "icon-right")
        ]))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}
}

})